<template>
	<section class="content">
		<div class="card-back w-100">
			<div class="card card-primary card-mx-auto">
				<div class="nav border-bottom">
					<div class="nav-item cursor-pointer" @click="changeMenu('service')">
						<h6 class="nav-link m-2 font-weight-bold" :class="(tabmenu == 'service' ? 'active text-primary' : 'text-secondary')">Data Service Kurir</h6>
					</div>
					<div class="nav-item cursor-pointer" @click="changeMenu('logs')">
						<h6 class="nav-link m-2 font-weight-bold" :class="(tabmenu == 'logs' ? 'active text-primary' : 'text-secondary')">Riwayat Perubahan</h6>
					</div>
					<div class="nav-item cursor-pointer d-flex align-items-center ml-auto mr-2" v-if="tabmenu == 'service'">
						<div class="btn-group" ref="toolbar">
							<button type="button" :disabled="downloading" v-on:click="downloadXlsx" data-action="export-xlsx" class="btn btn-primary">
								<span v-if="downloading" class="spinner-border spinner-border-sm"></span>
								<i v-else class="fi fi-rr-file-download"></i> 
								<span class="d-none d-md-inline-block ml-1">Download</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div :hidden="!(tabmenu == 'service')">
			<table class="table" ref="tablecourierservice" style="min-width: 100%;">
				<thead>
					<tr>
						<th>Service Code</th>
						<th>Service Name</th>
						<th>Kurir</th>
						<th>Percent Cashback</th>
						<th>Note</th>
					</tr>
				</thead>
				<tbody @click="handleClick"></tbody>
			</table>
		</div>

		<div :hidden="!(tabmenu == 'logs')">
			<table class="table table-hover row-border" ref="tablelogs">
				<thead>
					<tr>
						<th>Kurir Service</th>
						<th>Jenis Perubahan</th>
						<th>Tanggal Perubahan</th>
						<th>Approved By</th>
						<th>Sebelum Perubahan</th>
						<th>Setelah Perubahan</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table>
			<div class="text-center" :class="{ 'd-none' : emptyLogs }">
				<img :src="getImage('empty')" class="w-25" />
				<div class="h5 font-weight-bold">Riwayat perubahan kosong {{ emptyLogs }}</div>
				<p>Tidak ada riwayat perubahan pada rentang waktu ini atau pada filter yang kamu pilih</p>
			</div>
		</div>

		<div class="modal" tabindex="-1" role="dialog" ref="formDialog" data-backdrop="static">
			<div class="modal-dialog modal-lg" role="document">
				<div class="modal-content">
					<form role="form" @submit="submitForm">
						<div class="modal-header">
							<h5 class="modal-title">{{ formTitle }}</h5>
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<p v-if="errors.length" class="alert alert-danger alert-dismissible fade show" role="alert">
								<b>Please correct the following error(s):</b>
								<ul>
									<li v-for="error in errors" v-bind:key="error">{{ error }}</li>
								</ul>
								<button type="button" class="close" data-dismiss="alert" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</p>

							<div class="d-flex flex-column" style="gap: 1.25rem;">
								<div class="bg-light border border-light rounded pt-3 px-3">
									<h5 class="bg-white w-fit px-1 rounded" style="line-height: 1.5;margin-top: -1.65rem;margin-left: -0.25rem"><span class="text-gray">Info Layanan</span></h5>
									<div class="row">
										<div class="col-sm-6 col-md-3 form-group">
											<label for="service_code" class="control-label">Service Code</label>
											<input id="service_code" class="form-control" v-model="form.service_code" type="text" name="service_code" :readonly="this.method == 'PUT'" required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="courier_id" class="control-label">Kurir</label>
											<select id="courier_id" class="form-control" v-model="form.courier_id" name="courier_id" :disabled="this.method == 'PUT'" required>
												<option v-for="courier in groups" v-bind:key="courier.courier_id" v-bind:value="courier.courier_id">
													{{ courier.label }}
												</option>
											</select>
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="code" class="control-label">Code</label>
											<input id="code" class="form-control" v-model="form.code" type="text" name="code" required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="note" class="control-label">Note</label>
											<input id="note" class="form-control" v-model="form.note" type="text" name="note" required />
										</div>
									</div>
								</div>

								<div class="bg-light border border-light rounded pt-3 px-3">
									<h5 class="bg-white w-fit px-1 rounded" style="line-height: 1.5;margin-top: -1.65rem;margin-left: -0.25rem"><span class="text-gray">Cashback & Fee COD</span></h5>
									<div class="row justify-content-center">
										<div class="col-sm-6 col-md-3 form-group">
											<label for="percent_cashback" class="control-label">Percent Cashback</label>
											<input id="percent_cashback" class="form-control" v-model="form.percent_cashback" type="number" name="percent_cashback" min="0" @wheel.prevent step="0.01" placeholder="Bisa desimal" required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="return_cashback" class="control-label">Return Cashback</label>
											<input id="return_cashback" class="form-control" v-model="form.return_cashback" type="number" name="return_cashback" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="feecod_cashback" class="control-label">Fee COD Cashback</label>
											<input id="feecod_cashback" class="form-control" v-model="form.feecod_cashback" type="number" name="feecod_cashback" min="0" @wheel.prevent step="0.01" placeholder="Bisa desimal" required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="cod_max" class="control-label">COD Max</label>
											<input id="cod_max" class="form-control" v-model="form.cod_max" type="number" name="cod_max" min="0" @wheel.prevent required />
										</div>
									</div>
								</div>

								<div class="bg-light border border-light rounded pt-3 px-3">
									<h5 class="bg-white w-fit px-1 rounded" style="line-height: 1.5;margin-top: -1.65rem;margin-left: -0.25rem"><span class="text-gray">Pajak / PPN</span></h5>
									<div class="row justify-content-center">
										<div class="col-sm-6 col-md-3 form-group">
											<label for="ppncod_shipper" class="control-label">PPN COD Shipper</label>
											<input id="ppncod_shipper" class="form-control" v-model="form.ppncod_shipper" type="number" name="ppncod_shipper" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="ppn_ongkir_inc" class="control-label">PPN Ongkir Include</label>
											<input id="ppn_ongkir_inc" class="form-control" v-model="form.ppn_ongkir_inc" type="number" name="ppn_ongkir_inc" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="ppn_ongkir" class="control-label">PPN Ongkir</label>
											<input id="ppn_ongkir" class="form-control" v-model="form.ppn_ongkir" type="number" name="ppn_ongkir" min="0" @wheel.prevent step="0.01" placeholder="Bisa desimal" required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="ppn_insurance" class="control-label">PPN Insurance</label>
											<input id="ppn_insurance" class="form-control" v-model="form.ppn_insurance" type="number" name="ppn_insurance" min="0" @wheel.prevent step="0.01" placeholder="Bisa desimal" required />
										</div>
									</div>
								</div>

								<div class="bg-light border border-light rounded pt-3 px-3">
									<h5 class="bg-white w-fit px-1 rounded" style="line-height: 1.5;margin-top: -1.65rem;margin-left: -0.25rem"><span class="text-gray">Biaya Shipper</span></h5>
									<div class="row justify-content-center">
										<div class="col-sm-4 form-group">
											<label for="feecod_shipper" class="control-label">Fee COD Shipper</label>
											<input id="feecod_shipper" class="form-control" v-model="form.feecod_shipper" type="number" name="feecod_shipper" min="0" @wheel.prevent step="0.01" placeholder="Bisa desimal" required />
										</div>
										<div class="col-sm-4 form-group">
											<label for="volume_price" class="control-label">Volume Price</label>
											<input id="volume_price" class="form-control" v-model="form.volume_price" type="number" name="volume_price" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-4 form-group">
											<label for="status_drop_off" class="control-label">Status Drop Off</label>
											<input id="status_drop_off" class="form-control" v-model="form.status_drop_off" type="number" name="status_drop_off" min="0" @wheel.prevent required />
										</div>
									</div>
								</div>

								<div class="bg-light border border-light rounded pt-3 px-3">
									<h5 class="bg-white w-fit px-1 rounded" style="line-height: 1.5;margin-top: -1.65rem;margin-left: -0.25rem"><span class="text-gray">Asuransi</span></h5>
									<div class="row justify-content-center">
										<div class="col-sm-6 col-md-3 form-group">
											<label for="insurance_fee" class="control-label">Insurance Fee</label>
											<input id="insurance_fee" class="form-control" v-model="form.insurance_fee" type="number" name="insurance_fee" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="insurance_fee_min" class="control-label">Insurance Fee Min</label>
											<input id="insurance_fee_min" class="form-control" v-model="form.insurance_fee_min" type="number" name="insurance_fee_min" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="insurance_percent" class="control-label">Insurance Percent</label>
											<input id="insurance_percent" class="form-control" v-model="form.insurance_percent" type="number" name="insurance_percent" min="0" @wheel.prevent step="0.01" placeholder="Bisa desimal" required />
										</div>
										<div class="col-sm-6 col-md-3 form-group">
											<label for="insurance_min" class="control-label">Insurance Min</label>
											<input id="insurance_min" class="form-control" v-model="form.insurance_min" type="number" name="insurance_min" min="0" @wheel.prevent required />
										</div>
									</div>
								</div>

								<div class="bg-light border border-light rounded pt-3 px-3">
									<h5 class="bg-white w-fit px-1 rounded" style="line-height: 1.5;margin-top: -1.65rem;margin-left: -0.25rem"><span class="text-gray">Batas Berat & Harga</span></h5>
									<div class="row justify-content-center">
										<div class="col-sm-6 form-group">
											<label for="item_weight_max" class="control-label">Item Weight Max</label>
											<input id="item_weight_max" class="form-control" v-model="form.item_weight_max" type="number" name="item_weight_max" min="0" @wheel.prevent required />
										</div>
										<div class="col-sm-6 form-group">
											<label for="item_prices_max" class="control-label">Item Prices Max</label>
											<input id="item_prices_max" class="form-control" v-model="form.item_prices_max" type="number" name="item_prices_max" min="0" @wheel.prevent required />
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<div class="form-group h-100 ml-3 mb-0 mr-auto">
								<div class="icheck-material-orange w-100">
									<input type="checkbox" id="active" v-model="form.active" />
									<label for="active" class="form-check-label w-100 font-weight-bold">{{ form.active ? '' : 'Not' }} Active</label>
								</div>
							</div>
							<button type="submit" class="btn btn-primary">
								Save changes
							</button>
							<button type="button" class="btn btn-secondary" data-dismiss="modal">
								Close
							</button>
						</div>
					</form>
				</div>
			</div>
		</div>
	</section>
	<!-- /.content -->
</template>
<script>
import { createTable, authFetch } from "@/libs/hxcore";
import Swal from "sweetalert2";
import moment from "moment";
import "icheck-material";
import $ from "jquery";

export default {
	name: "dataServiceKurir",
	data() {
		return {
			errors: [],
			method: "",
			roles: "",
			tabmenu: 'service',
			downloading: false,
			groups: [],
			formTitle: "Tambah Service Kurir",
			form: {
				id: null,
				service_code: null,
				courier_id: null,
				code: null,
				note: null,
				percent_cashback: 0,
				return_cashback: 0,
				feecod_cashback: 0,
				cod_max: 0,
				ppncod_shipper: 0,
				ppn_ongkir_inc: 0,
				ppn_ongkir: 0,
				ppn_insurance: 0,
				feecod_shipper: 0,
				volume_price: 0,
				status_drop_off: 0,
				insurance_fee: 0,
				insurance_fee_min: 0,
				insurance_percent: 0,
				insurance_min: 0,
				item_weight_max: 0,
				item_prices_max: 0,
				active: false,
			},
			emptyLogs: false
		};
	},
	created: function () {
		this.roles = this.$route.meta.roles;
		console.log("load initial data", this.$route);

		//get data courier for dropdown select
		authFetch("/shipper/kurir")
		.then((res) => {
			if (res.status === 201) {
			} else if (res.status === 400) {
			}
			return res.json();
		})
		.then((js) => {
			this.groups = js.data;
		});
	},
	methods: {
		changeMenu(tipe) {
			$('.loading-overlay').addClass('show');
			if (this.tabmenu == tipe) {
				$('.loading-overlay').addClass('hide');
				return false;
			} else if (tipe == 'service') {
				this.loadService();
			} else if (tipe == 'logs') {
				this.loadLogs();
			} else {
				this.tabmenu = tipe;
			}
		},
		getImage(file) {
			return require(`../../assets/img/${file}.svg`); // the module request
		},
		getDate(time, hour = '') {
			return moment(time).format('DD/MM/YYYY ' + hour);
		},
		loadService: function (ev) {
			if (this.tableService) {
				this.tableService.api().ajax.reload(null, false);
			} else {
				const e = this.$refs;
				var self = this;
				this.tableService = createTable(e.tablecourierservice, {
					title: "Data Service Kurir",
					roles: this.$route.params.roles,
					ajax: "/master/courier/service",
					processing: true,
					filterBy: [0, 1, 2],
					frame: true,
					responsive: true,
					scrollX: true,
					language: {
						processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
					columns: [
						{ data: "service_code" },
						{ data: "code" },
						{ data: "nama" },
						{ data: "percent_cashback" },
						{ data: "note" },
					],
					rowCallback: function (row, data) {
						if (data.percent_cashback) {
							$("td:eq(2)", row).html("<h6>" + data.percent_cashback + "%</h6>");
						}
					},
					buttonClick: (evt) => {
						if (evt.role == "create") {
							self.form = {
								id: null,
								service_code: null,
								courier_id: null,
								code: null,
								note: null,
								percent_cashback: 0,
								return_cashback: 0,
								feecod_cashback: 0,
								cod_max: 0,
								ppncod_shipper: 0,
								ppn_ongkir_inc: 0,
								ppn_ongkir: 0,
								ppn_insurance: 0,
								feecod_shipper: 0,
								volume_price: 0,
								status_drop_off: 0,
								insurance_fee: 0,
								insurance_fee_min: 0,
								insurance_percent: 0,
								insurance_min: 0,
								item_weight_max: 0,
								item_prices_max: 0,
								active: false,
							};
							self.method = "POST";
							self.errors = [];
							self.formTitle = "Tambah Service Kurir";
							$(e.formDialog).modal("show");
						} else if (evt.role == "update" && evt.data) {
							self.form = evt.data;
							console.log(evt.data);
							self.form.active = evt.data.active == 0 ? false : true; //operator d
							self.method = "PUT";
							self.errors = [];
							self.formTitle = "Edit Service Kurir";
							$(e.formDialog).modal("show");
						} else if (evt.role == "delete" && evt.data) {
							console.log(evt);
							Swal.fire({
								title: "Hapus data?",
								icon: "question",
								denyButtonText: '<i class="fa fa-times"></i> Hapus',
								showCancelButton: true,
								showDenyButton: true,
								showConfirmButton: false,
							}).then((result) => {
								if (result.isDenied) {
									authFetch("/master/courier/service/" + evt.data.id, {
										method: "DELETE",
										body: "id=" + evt.data.id,
									})
									.then((res) => {
										return res.json();
									})
									.then((js) => {
										self.loadService();
									});
								}
							});
						}
					},
					initComplete: function () {
						$('.loading-overlay').removeClass('show');
					},
				});
			}

			this.tabmenu = 'service';
			this.processing = false;
			$('.loading-overlay').removeClass('show');
		},
		loadLogs: function() {
			if (this.tableLogs) {
				this.loadService();
				this.tabmenu = 'logs';
				$('.loading-overlay').removeClass('show');
			} else {
				const e = this.$refs;
				const self = this;

				this.tableLogs = createTable(e.tablelogs, {
					title: "Riwayat Perubahan",
					ajax: "/master/courier/history_service",
					frame: true,
					lengthChange: true,
					filter: false,
					filterBy: [],
					stateSave: true,
					processing: true,
					autoWidth: false,
					language: {
						processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'
					},
					// paramData: function (d) {
						// var filter = JSON.parse(JSON.stringify(self.filter_log));
						// for (const key in filter) {
						// 	d[key] = filter[key] === false ? 0 : filter[key];
						// }
					// },
					"order": [
						[2, 'desc']
					],
					columns: [
						{
							data: 'nama',
							render: function (data, type, row, meta) {
								return data + '\u00A0\u2014\u00A0' + row.service_code
							}
						},
						{
							data: 'history',
							render: function (data, type, row, meta) {
								var col = '';
								for (let x of Object.keys(JSON.parse(data))) {
									// col += x == 'tbl' ? '' : x[0].toUpperCase() + x.slice(1) + '<br>';
									/*
									"Kata Sandi":{"tbl":"users",%"password_hash":%
									*/
									col += x == 'tbl' ? '' : x + '<br>';
								}
								return col.substring(0, col.length - 4);
							}
						},
						{
							data: 'created_on',
							render: function (data, type, row, meta) {
								return self.getDate(data, '- HH:mm');
							}
						},
						{ data: 'display_name' },
						{
							data: 'history',
							render: function (data, type, row, meta) {
								var col = '';
								var data = JSON.parse(data);
								for (let x of Object.keys(data)) {
									col += x == 'tbl' ? '' : data[x][0] + '<br>';
								}
								return col.substring(0, col.length - 4);
							},
							sortable: false
						},
						{
							data: 'history',
							render: function (data, type, row, meta) {
								var col = '';
								var data = JSON.parse(data);
								for (let x of Object.keys(data)) {
									col += x == 'tbl' ? '' : data[x][1] + '<br>';
								}
								return col.substring(0, col.length - 4);
							},
							sortable: false
						},
					],
					drawCallback: function (row, data) {
						self.emptyLogs = row._iRecordsTotal > 0;
					},
					initComplete: function () {
						self.tabmenu = 'logs';
						$('.loading-overlay').removeClass('show');
					}
				});
			}
		},
		handleClick(e) {
			if (e.target.matches(".link-role")) {
				this.$router.push({ path: "/permit/" + e.target.dataset.id });
				return false;
			}
		},
		submitForm: function (ev) {
			const e = this.$refs;
			var data = Object.keys(this.form)
				.map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key]))
				.join("&");
			var urlSubmit = "/master/courier/service";
			if (this.method == "PUT")
				urlSubmit = "/master/courier/service/" + this.form.id;

			authFetch(urlSubmit, {
				method: this.method,
				body: data,
			})
			.then((res) => {
				if (res.status === 201) {
				} else if (res.status === 400) {
				}
				return res.json();
			})
			.then((js) => {
				this.errors = [];
				if (!js.success) {
					console.log(js.details);

					for (var key in js.details) {
						if (js.details.hasOwnProperty(key)) {
							this.errors.push(js.details[key]);
						}
					}

					return;
				}
				this.loadService();
				$(e.formDialog).modal("hide");
			});

			ev.preventDefault();
		},
		downloadXlsx: function (e) {
			var filter = {};
				filter.q = $("input[name=q]").val();
				filter.category = $("select[name=category]").val();

			var data = Object.keys(filter)
				.map(
					(key) =>
					encodeURIComponent(key) + "=" + (filter[key] === false ? 0 : encodeURIComponent(filter[key]))
				)
				.join("&");

			this.downloading = true;
			authFetch("/master/courier/data_service?" + data, {
				method: "GET",
			})
			.then((response) => {
				if (response.status === 201) {
				} else if (response.status === 400) {
				} else if (response.status === 500){
					Swal.fire("Timeout!", ``, "error");
					return false;
				}
				return response.blob();
			})
			.then((blob) => {
				setTimeout(() => {
					this.downloading = false;
				}, 1000);
				var url = window.URL.createObjectURL(blob);
				var a = document.createElement("a");
				a.href = url;
				a.download = "master_service_courier.xlsx";
				document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
				a.click();
				a.remove(); //afterwards we remove the element again
			});
		},
	},
	mounted() {
		this.loadService();
	},
};
</script>